import React, { useState } from 'react';
import { Button } from 'antd';
import { CallIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal } from 'modules/auth';
import { useInteractionHandler, UserInteraction } from 'modules/global';

import { ApplicationModal } from 'components';

interface IProps {
  setOpen: (open: boolean) => void;
  id?: string;
  phone?: string;
  testAvailable?: boolean;
}

const MainInformation: React.FC<IProps> = ({ setOpen, id, phone, testAvailable }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { onInteractionClick } = useInteractionHandler(id);
  const [openApplicationCreate, setOpenApplicationCreate] = useState(false);
  const isAuthorized = useAppSelector(({ user }) => user.phone);

  const onClick = () => {
    if (testAvailable) {
      return setOpen(true);
    }

    if (!isAuthorized) {
      return dispatch(openAuthModal());
    }

    return setOpenApplicationCreate(true);
  };

  return (
    <div className="rounded-xl bg-white p-3">
      <div className="h-25 max-w-45 relative mx-auto flex aspect-[1.95] w-full items-center justify-center">
        <Image src="/images/test-paper.webp" alt="TEST PAPER" title="Test varog`i" fill />
      </div>
      <div className="mt-4 space-y-2">
        <Link
          target="_blank"
          href={`tel:${phone}`}
          onClick={onInteractionClick(UserInteraction.PHONE_CLICK)}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-gray-100 py-2.5 text-sm font-medium"
        >
          <CallIcon />
          {t('qongiroq_qilish')}
        </Link>
        <Button
          onClick={onClick}
          className="!py-4.5 !w-full !rounded-lg !border-transparent !bg-green-500 !text-base !text-white hover:!bg-green-600"
        >
          {testAvailable ? t('imtihon_topshirish') : t('ArizaQoldirish')}
        </Button>
      </div>

      <ApplicationModal
        universityId={id}
        open={openApplicationCreate}
        onClose={() => setOpenApplicationCreate(false)}
      />
    </div>
  );
};

export default MainInformation;
